import React, { useEffect, useState } from "react";
import { FaPrint, FaMoneyBillWave } from "react-icons/fa";
import axios from "axios";

const Groceryprocurementcart = () => {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const fetchCartData = async () => {
      const vendorId = localStorage.getItem("vendorId");
      const token = localStorage.getItem("authToken");

      if (!vendorId || !token) {
        alert("Vendor ID or token missing");
        return;
      }

      try {
        const res = await axios.get(
          `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/inventory/grocery/cart/all`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCart(res.data || []);
      } catch (error) {
        console.error("Error fetching procurement cart:", error);
        alert("Failed to load procurement cart.");
      }
    };

    fetchCartData();
  }, []);

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const tableRows = cart.map(
      (item, index) =>
        `<tr>
          <td>${index + 1}</td>
          <td>${item.itemName}</td>
          <td>${item.procurementQuantity}</td>
        </tr>`
    ).join("");

    const printContent = `
      <html>
        <head>
          <title>Procurement Cart</title>
          <style>
            table {
              width: 100%;
              border-collapse: collapse;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: center;
            }
            th {
              background-color: #b15cd6;
              color: white;
            }
          </style>
        </head>
        <body>
          <h3>Procurement Cart</h3>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Item Name</th>
                <th>Procure Qty</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </body>
      </html>
    `;
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };

  const handlePay = () => {
    const totalAmount = cart.reduce(
      (sum, item) => sum + (item.procurementQuantity * 100), // Assuming ₹100 per item
      0
    );

    const options = {
      key: "rzp_test_vbkGmNwNGHs88H", // Replace with your Razorpay key
      amount: totalAmount * 100, // in paise
      currency: "INR",
      name: "Vendor Procurement",
      description: "Procurement Cart Payment",
      handler: function (response) {
        alert("✅ Payment successful. Razorpay ID: " + response.razorpay_payment_id);
      },
      prefill: {
        name: "Vendor",
        email: "vendor@example.com",
        contact: "9999999999",
      },
      theme: {
        color: "#b15cd6",
      },
    };

    const razor = new window.Razorpay(options);
    razor.open();
  };

  const tableHeaderStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
  };

  const tableCellStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
  };

  const buttonStyle = {
    padding: "8px 16px",
    margin: "10px 10px 0 0",
    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  };

  if (cart.length === 0) return <p>No items in the procurement cart.</p>;

  return (
    <div style={{ marginTop: "20px" }}>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "10px",
        }}
      >
        <thead>
          <tr>
            <th style={tableHeaderStyle}>S.No</th>
            <th style={tableHeaderStyle}>Item Name</th>
            <th style={tableHeaderStyle}>Procure Qty</th>
          </tr>
        </thead>
        <tbody>
          {cart.map((item, index) => (
            <tr key={item.id || index}>
              <td style={tableCellStyle}>{index + 1}</td>
              <td style={tableCellStyle}>{item.itemName}</td>
              <td style={tableCellStyle}>{item.procurementQuantity}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ textAlign: "right" }}>
        <button style={buttonStyle} onClick={handlePrint}>
          <FaPrint style={{ marginRight: "5px" }} /> Print
        </button>
        <button style={buttonStyle} onClick={handlePay}>
          <FaMoneyBillWave style={{ marginRight: "5px" }} /> Pay
        </button>
      </div>
    </div>
  );
};

export default Groceryprocurementcart;
